var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthRequest } from "../utils/requests";
import { BasicError } from "../utils/dom";
import { getParam, removeParam } from "../utils/urlQuery";
function doError(text) {
    var cont = document.getElementById("error-container");
    var error = BasicError(text);
    cont.appendChild(error);
    setTimeout(() => {
        error.classList.add("hide");
    }, 5000);
}
var main = document.getElementById("main");
var codeStorage = "";
document.getElementById("button_send").addEventListener("click", () => __awaiter(void 0, void 0, void 0, function* () {
    main.switchTab("loader");
    var data = yield AuthRequest("/api/pwreset/send", {
        "email": document.getElementById("input_email").value.trim()
    });
    if (data['success'] == true) {
        main.switchTab("code");
    }
    else {
        doError(data.message);
        main.switchTab("begin");
    }
}));
document.getElementById("button_check").addEventListener("click", () => __awaiter(void 0, void 0, void 0, function* () {
    main.switchTab("loader");
    var data = yield AuthRequest("/api/pwreset/verify", {
        "code": document.getElementById("input_code").value.trim()
    });
    if (data['success'] == true) {
        codeStorage = document.getElementById("input_code").value.trim();
        main.switchTab("reset");
    }
    else {
        doError(data.message);
        main.switchTab("begin");
    }
}));
document.getElementById("button_reset").addEventListener("click", () => __awaiter(void 0, void 0, void 0, function* () {
    main.switchTab("loader");
    var data = yield AuthRequest("/api/pwreset/reset", {
        "code": codeStorage,
        "password": document.getElementById("input_password").value
    });
    if (data['success'] == true) {
        location.href = "/login";
    }
    else {
        doError(data.message);
        main.switchTab("reset");
    }
}));
var tried = false;
main.addEventListener("page-open", () => __awaiter(void 0, void 0, void 0, function* () {
    if (tried)
        return;
    tried = true;
    if (getParam("code", null) != null) {
        setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            main.switchTab("loader");
            var data = yield AuthRequest("/api/pwreset/verify", {
                "code": getParam("code", null)
            });
            if (data['success'] == true) {
                main.switchTab("reset");
            }
            else {
                removeParam("code");
                doError(data.message);
                main.switchTab("begin");
            }
        }), 50);
    }
}));
